const messagesTR = {
    code: "tr",
    messages: {
        included: (field) => `"${field}" alanına geçerli bir değer giriniz`,
        url: (field) => `"${field}" alanının geçerli bir url olması gerekir`,
        alpha: (field) => `"${field}" yalnızca harf içerebilir`,
        alpha_dash: (field) => `"${field}" alanı harf ve tire (-) ya da alttan tire (_) içerebilir`,
        alpha_num: (field) => `"${field}" yalnızca harf veya rakam içerebilir`,
        alpha_spaces: (field) => `"${field}" yalnızca harf boşluk (space) içerebilir`,
        between: (field, min, max) => `"${field}" ${min} ile ${max} aralığında olmalıdır`,
        confirmed: (field, field2) => `"${field}" doğrulaması hatalı, ${field2} ve ${field} aynı olmalıdır`,
        digits: (field, length) => `"${field}" sayısal ve ${length} basamaklı olmalıdır`,
        dimensions: (field, width, height) =>
            `"${field}" alanı ${width} piksel ile ${height} piksel arasında olmalıdır`,
        email: (field) => `"${field}" alanının geçerli bir e-posta olması gerekir`,
        excluded: (field) => `"${field}" geçerli bir değer değildir.`,
        ext: (field) => `"${field}" alanı geçerli bir dosya olmalıdır`,
        image: (field) => `"${field}" alanı resim dosyası olmalıdır`,
        oneOf: (field) => `"${field}" alanına geçerli bir değer giriniz`,
        max: (field, length) => `"${field}" alanı ${length} karakterden fazla olmamalıdır`,
        max_value: (field, max) => `"${field}" alanı ${max} ya da daha az bir değer olmalıdır`,
        mimes: (field) => `"${field}" geçerli bir dosya olmalıdır`,
        min: (field, length) => `"${field}" alanına en az ${length} karakter girilmelidir`,
        min_value: (field, min) => `"${field}" alanı ${min} ya da daha fazla bir değer olmalıdır`,
        numeric: (field) => `"${field}" alanına sayısal bir değer giriniz`,
        regex: (field) => `"${field}" formatı geçersiz`,
        required: (field) => `"${field}" alanı gereklidir`,
        required_if: (field) => `"${field}" alanı gereklidir`,
        size: (field, size) => `"${field}" alanı ${size}KB'dan daha az olmalıdır`,
        length: (field, len) => `"${field}" alanı ${len} karakter olmalıdır`,
    },
};

export default messagesTR;
